import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Docket from '../../entities/docket';
import Task from '../../entities/task';

/*
 * Delete/nullify anywhere this docket is used in other entities
 *
 * @param {Docket} docket
 */
export function deleteDocket(docket: Docket, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = docket.id;
    }
    /* Simple delete usages */
        
    store.getState().tasks
        .getMappingFor('docketId', docket.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.docketId = null;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    /* Remove the actual docket */
    docket.status = 'D';
    docket.addedOn = newHRTimestamp();
    docket.addedBy = getCurrentUserId();
    docket.importSource = targetImportSource;
    docket.importId = mergeId;
    store.dispatch(Actions.DocketActions.removeDocketQueue(docket));
    
}

/*
 * Replace anywhere this docket is used in other entities.
 *
 * @param {Docket} docket
 * @param {Docket} replaceWith
 * @return {Docket} - Docket will have refs stripped away
 */
export function replaceDocket(docket: Docket, replaceWith: Docket, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = docket.id;
    }
    /* Simple replace usages */
        
    store.getState().tasks
        .getMappingFor('docketId', docket.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.docketId = replaceWith.id;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    return docket;
}

/*
 * Determine the impact of deleting this docket from other entities
 *
 * @param {Docket} docket
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactDocket(docket: Docket) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const taskDocketIdImpact = state.tasks
          .getMappingFor('docketId', docket.id)
          .filter(task => task.status !== 'D');

    taskDocketIdImpact.forEach(() => impacts.push('tasks'));

    return util.countDistinct(impacts);
}